import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Button as MuiButton } from '@mui/material';
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function AddFilter() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [quadrants, setQuadrants] = useState([]);
  const [filter, setFilter] = useState({
    quadrant: "",
    index: "",
    name: ""
  });

  // Load quadrants for dropdown
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}common/quadrants`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => setQuadrants(data))
      .catch(console.error);
  }, []);

  const addFilter = async () => {
    const { quadrant, index, name } = filter;
    if (!quadrant || !index || !name) {
      alert("Please select Quadrant, and fill Filter Index & Name.");
      return;
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}common/filters`,
        filter,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Filter created successfully!");
      navigate("/filter-list");
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.message || "Error creating filter.");
    }
  };

  return (
    <PageLayout>
      <Grid container spacing={3} sx={{ alignItems: "center", mb: 3 }}>
        <Grid size={{ xs: 12, sm: 6 }}><Breadcrumb title="Add Filter" /></Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: "end" }}>
          <Link to="/filter-list">
            <MuiButton variant="contained" color="secondary">Back to List</MuiButton>
          </Link>
        </Grid>
      </Grid>

      <Box className="mc-card">
        <Grid container spacing={3}>
          {/* Quadrant */}
          <Grid size={12}>
            <CardHeader title="Quadrant" />
            <TextField
              select
              fullWidth
              value={filter.quadrant}
              onChange={e => setFilter({ ...filter, quadrant: e.target.value })}
            >
              {quadrants.map(q => (
                <MenuItem key={q._id} value={q._id}>
                  {q.name} (Tab Index: {q.tab?.index}, Quadrant: {q.index})
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* Filter Index */}
          <Grid size={12}>
            <CardHeader title="Filter Index" />
            <TextField
              type="number"
              fullWidth
              placeholder="1–9"
              value={filter.index}
              onChange={e => setFilter({ ...filter, index: e.target.value })}
            />
          </Grid>

          {/* Filter Name */}
          <Grid size={12}>
            <CardHeader title="Filter Name" />
            <TextField
              fullWidth
              placeholder="e.g. Rigid"
              value={filter.name}
              onChange={e => setFilter({ ...filter, name: e.target.value })}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ mt: 3 }}>
          <Grid size={12} sx={{ textAlign: "end" }}>
            <MuiButton variant="contained" color="primary" onClick={addFilter}>
              Create Filter
            </MuiButton>
          </Grid>
        </Grid>
      </Box>
    </PageLayout>
  );
}
